var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKakaoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_591_95)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50002 1.09998C4.52917 1.09998 0.5 4.21293 0.5 8.05226C0.5 10.44 2.0584 12.5449 4.43152 13.7969L3.43303 17.4445C3.34481 17.7668 3.71341 18.0237 3.99646 17.8369L8.37334 14.9482C8.7427 14.9838 9.11808 15.0046 9.50002 15.0046C14.4705 15.0046 18.4999 11.8918 18.4999 8.05226C18.4999 4.21293 14.4705 1.09998 9.50002 1.09998Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_591_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9999,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaoIcon);
export default __webpack_public_path__ + "static/media/kakaoIcon.72731017c6d2af4fd3d1ec82be2845b9.svg";
export { ForwardRef as ReactComponent };